export default __webpack_public_path__ + "static/media/ENS.3f8a262e.jpg";